import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {TranslationService} from '@emma-labs/shared/angular';
import {MIBCodedReport} from '@emma-labs/shared/typescript';
import {TableModule} from 'primeng/table';
import {TooltipModule} from 'primeng/tooltip';
import {formatOptionalCountryStateAndTerritory} from '../utils';

@Component({
  selector: 'em-coded-report-section',
  templateUrl: './coded-report-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TableModule, TooltipModule],
})
export class CodedReportSectionComponent {
  @Input({required: true}) data!: MIBCodedReport[];

  constructor(private readonly translate: TranslationService) {}

  getResidencePlace(report: MIBCodedReport) {
    return formatOptionalCountryStateAndTerritory(
      report.residenceCountry,
      report.residenceState,
      report.residenceTerritory,
      this.translate.getCurrentLanguageCode(),
    );
  }
}
